import styled from "styled-components";

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.9rem;
  font-weight: 500;
`;

export const Input = styled.input`
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
`;